import { render, staticRenderFns } from "./ChargeRecord.vue?vue&type=template&id=b5f1be9c&"
import script from "./ChargeRecord.vue?vue&type=script&lang=js&"
export * from "./ChargeRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChargeRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports